import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import {
  base_colorSurfaceMutedHover,
  input_backgroundDefault,
  input_borderDefault,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.CreditCardDropdownV2 {
    max-height: 38px;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid ${input_borderDefault};
    background-color: ${input_backgroundDefault};

    &:hover:not(.selected) {
      background-color: ${base_colorSurfaceMutedHover};
    }

    &.selected {
      background-color: ${styleConstants.colors.blue_opacity};
      border: 1px solid ${themeConstants.colors.cta};
    }
  }
`

export const loadingOption = css`
  display: flex;
  align-items: center;
  height: 52px;
  margin-left: 24px;
  ${getFontCss(
      14,
      themeConstants.colors.font_primary,
      styleConstants.fontFamilies.italic,
    )};

  &.small {
    padding: 8px;
  }

  &.medium {
    padding: 8px 16px;
  }
`

export const emptyState = css`
  padding: ${spacing(4)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing(5)};
  text-align: center;
  & .title {
    font-family: ${font_family_weight_medium};
    ${font_md}
  }

  & .subtitle {
    ${font_md}
  }
`